import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { InputWithButtonEdit } from '@/pages/_base/inputs/InputWithButtonEdit';
import { remote_workspace_update } from '@/state/workspace/entity/remote_workspace_update';
import { useState } from 'react';

export function WSTableUserCreditLimitsInputTemplate() {
  const dispatch = use_dispatch();

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const [value, set_value] = useState(workspace_current.credit_limit_for_new_workspace_users);
  const [value_default, set_value_default] = useState(workspace_current.credit_limit_for_new_workspace_users);

  const [is_loading, set_is_loading] = useState(false);

  /*
   * EVENTS
   */

  async function onChangeCommited(value_string: string) {
    let value_new = value_string === '' ? 0 : Number(value_string.replace(/\D/g, ''));

    set_value(value_new);

    if (value_new === workspace_current.credit_limit_for_new_workspace_users) return;

    set_value_default(value_new);

    let workspace_new = workspace_current.clone({ credit_limit_for_new_workspace_users: value_new });

    set_is_loading(true);
    await dispatch(remote_workspace_update(workspace_new));
    set_is_loading(false);
  }

  function onChange(value_string: string) {
    const value_number = Number(value_string.replace(/\D/g, ''));

    set_value(value_number);
  }

  /*
   * METHODS
   */

  function is_disabled() {
    return is_loading || !workspace_current.credit_limit_for_new_workspace_users_enabled;
  }

  /*
   * HTML
   */

  return (
    <InputWithButtonEdit
      disabled={is_disabled()}
      value={String(value)}
      value_default={String(value_default)}
      {...{ onChange, onChangeCommited }}
      is_format_compact_number
      className="min-h-9 max-h-9 h-9"
    />
  );
}
